import React from "react";
import { PROFILE } from "@/data/portfolio";
import { FOOTER } from "@/constants/testIds";
import { FiGithub, FiLinkedin, FiMail } from "react-icons/fi";

export default function Footer() {
  return (
    <footer data-testid={FOOTER.root} className="relative border-t border-[color:var(--border)] py-12 mt-8">
      <div className="container-x grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        <div>
          <div className="font-display text-2xl">
            Suyash<span className="text-[color:var(--accent)]">.</span>
          </div>
          <p className="mt-2 font-mono text-xs text-[color:var(--text-muted)]">
            Crafted with React, Tailwind & Motion. © {new Date().getFullYear()}
          </p>
        </div>
        <div className="text-center font-mono text-xs text-[color:var(--text-muted)]">
          <p>{PROFILE.location} · UTC+5:30</p>
        </div>
        <div className="flex md:justify-end items-center gap-3">
          <a
            href={PROFILE.github}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="w-10 h-10 rounded-full border border-[color:var(--border)] flex items-center justify-center hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] transition"
          >
            <FiGithub size={16} />
          </a>
          <a
            href={PROFILE.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="w-10 h-10 rounded-full border border-[color:var(--border)] flex items-center justify-center hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] transition"
          >
            <FiLinkedin size={16} />
          </a>
          <a
            href={`mailto:${PROFILE.email}`}
            aria-label="Email"
            className="w-10 h-10 rounded-full border border-[color:var(--border)] flex items-center justify-center hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] transition"
          >
            <FiMail size={16} />
          </a>
        </div>
      </div>
    </footer>
  );
}
